module.exports.main = `
  INSERT INTO fin.purchase (
      origin, company, txn_id, txn_date,
      customer_id, account_id, amount, currency, private_note
  )
  SELECT origin
       , company
       , txn_id
       , txn_date
       , (data->'EntityRef'->>'value')::INTEGER as customer_id
       , (data->'AccountRef'->>'value')::INTEGER as account_id
       , (data->>'TotalAmt')::NUMERIC as amount
       , (data->'CurrencyRef'->>'value')::fin.currency_type as currency
       , (data->>'PrivateNote') as private_note
  FROM raw
`
module.exports.line = `
  INSERT INTO fin.purchase_line (
      origin, company, txn_id, line_num,
      amount, account_id, customer_id, tax_code, description
  )
  SELECT origin
       , company
       , txn_id
       , line_num
       , (line->>'Amount')::NUMERIC as amount
       , (line->'AccountBasedExpenseLineDetail'->'AccountRef'->>'value')::INTEGER
         as account_id
       , (line->'AccountBasedExpenseLineDetail'->'CustomerRef'->>'value')::INTEGER
         as customer_id
       , (line->'AccountBasedExpenseLineDetail'->'TaxCodeRef'->>'value') as tax_code
       , (line->>'Description') as description
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line')
             WITH ORDINALITY AS l(line, line_num) ON TRUE
  WHERE line->>'DetailType' = 'AccountBasedExpenseLineDetail'
`

module.exports.rawCustomerIds = `
  SELECT origin
       , company
       , (data->'EntityRef'->>'value')::INTEGER as customer_id
  FROM raw
  UNION
  SELECT origin
       , company
       , (line->'AccountBasedExpenseLineDetail'->'CustomerRef'->>'value')::INTEGER
         as customer_id
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line') AS line ON TRUE
  WHERE line->>'DetailType' = 'AccountBasedExpenseLineDetail'
`

module.exports.rawAccountIds = `
  SELECT origin
       , company
       , (line->'AccountBasedExpenseLineDetail'->'AccountRef'->>'value')::INTEGER
         as account_id
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line') AS line ON TRUE
  WHERE line->>'DetailType' = 'AccountBasedExpenseLineDetail'
`
